import React from 'react';
import { useTranslation } from 'react-i18next';
import * as S from './LimitsCard.styles';
import { LimitsListItem } from '@/features/Profile/sections/Limits/api';
import { useResponsive } from '@/hooks/useResponsive';
import { formatDate } from '@/utils/helpers';

export const LimitsCard = ({ item }: { item: LimitsListItem }) => {
  const { isDesktop } = useResponsive();
  const { t } = useTranslation();

  const {
    iconUrl,
    categoryName,
    subcategoryName,
    freeCount,
    paidCount,
    totalCount,
    limitUntil,
  } = item;
  const freeLabelKey = isDesktop
    ? 'pages.cabinet.free_ads'
    : 'pages.cabinet.free_ads_short';
  const paidLabelKey = isDesktop
    ? 'pages.cabinet.paid_ads'
    : 'pages.cabinet.paid_ads_short';
  const isFreeExhausted = freeCount === 0;

  function renderStat(label: string, value: number) {
    return (
      <S.Stat>
        <S.StatLabel>{label}</S.StatLabel>
        <S.StatValue>{value}</S.StatValue>
      </S.Stat>
    );
  }

  return (
    <S.Card>
      <S.Header>
        <S.ImgBox>
          <img src={iconUrl ?? ''} alt={subcategoryName} />
        </S.ImgBox>
        <S.Names>
          <S.Name>{categoryName}</S.Name>
          <S.SubName>{subcategoryName}</S.SubName>
        </S.Names>
      </S.Header>

      <S.Stats>
        <S.Stat>
          <S.StatLabel>{t(freeLabelKey)}</S.StatLabel>
          <S.StatValueWrap>
            <S.StatValue $isRed={isFreeExhausted}>{freeCount}</S.StatValue>
            {isFreeExhausted && limitUntil && (
              <S.UntilDate>
                /{' '}
                {t('pages.cabinet.until_date', {
                  date: formatDate(limitUntil, 'dd.MM.yyyy'),
                })}
              </S.UntilDate>
            )}
          </S.StatValueWrap>
        </S.Stat>
        {renderStat(t(paidLabelKey), paidCount)}
        {!isDesktop && renderStat(t('pages.cabinet.total'), totalCount)}
      </S.Stats>
    </S.Card>
  );
};
